/**
 * Mainbeauty — lớp chuyển động: reveal khi cuộn, nhích mũi tên CTA, lệch pha chấm tiêu đề.
 */
import { observeRevealElements } from "./scrollReveal.js";

// Các khối đọc như "thẻ xếp thành hàng" trên toàn site.
const REVEAL_SELECTOR = [
  ".pi-shead",
  ".card",
  ".tier",
  ".post",
  ".feat",
  ".mod",
  ".vidc",
  ".scard",
  ".pi-vidcard",
  ".pi-step",
  ".pi-pillar",
].join(",");

const ARROW_RE = /([→←↑↓➜➔»›↗])\s*$/;

const SLINE_DURATION = 6; // phải khớp pi-sline-run trong _component/_motion.scss

// Opt-out bằng [data-pi-no-motion]; trong carousel thì clone của Owl sẽ replay.
function shouldSkip(el) {
  return (
    el.closest("[data-pi-no-motion]") !== null ||
    el.closest("[data-pi-carousel]") !== null ||
    el.closest(".owl-carousel") !== null
  );
}

function initReveal(root) {
  const groups = new Map();

  root.querySelectorAll(REVEAL_SELECTOR).forEach((el) => {
    if (el.classList.contains("js-reveal") || shouldSkip(el)) return;
    if (el.parentElement && el.parentElement.closest(".js-reveal")) return; // thẻ trong thẻ sẽ fade hai lần
    el.classList.add("js-reveal");

    // Lệch pha anh em để cả hàng thẻ đổ dần thay vì bật ra cùng lúc.
    const parent = el.parentElement;
    const index = groups.get(parent) || 0;
    groups.set(parent, index + 1);
    if (index) el.style.setProperty("--pi-reveal-delay", index * 0.09 + "s");
  });

  observeRevealElements();
}

function initArrows(root) {
  root
    .querySelectorAll(".btn, .btn2, .nav__cta, .mod__try, [data-pi-arrow]")
    .forEach((el) => {
      if (el.querySelector(".pi-arrow") || shouldSkip(el)) return;

      // Chỉ text node cuối — mũi tên giữa câu không phải dấu hiệu CTA.
      const node = Array.from(el.childNodes)
        .reverse()
        .find((n) => n.nodeType === Node.TEXT_NODE && n.textContent.trim());
      if (!node) return;

      const match = ARROW_RE.exec(node.textContent);
      if (!match) return;

      const span = document.createElement("span");
      span.className =
        "pi-arrow" + (/[↓]/.test(match[1]) ? " pi-arrow--down" : "");
      span.textContent = match[1];
      // Lệch pha để cả hàng nút không nhích cùng nhịp.
      span.style.setProperty("--pi-arrow-delay", (Math.random() * 2).toFixed(2) + "s");

      node.textContent = node.textContent.replace(ARROW_RE, "");
      el.insertBefore(span, node.nextSibling);
    });
}

// Rải pha theo tỉ lệ vàng, delay ÂM để chấm bắt đầu giữa đường chứ không đỗ ở mép trái.
// 🚨 Ghi thẳng animationDelay, không qua var(): Safari iOS không promote animation có custom property.
function initSlines(root) {
  let index = 0;

  root.querySelectorAll(".pi-sline__dot").forEach((el) => {
    if (el.style.animationDelay || shouldSkip(el)) return;
    const phase = (index++ * 0.618 * SLINE_DURATION) % SLINE_DURATION;
    el.style.animationDelay = "-" + phase.toFixed(2) + "s";
  });
}

export function initMotion(root = document) {
  initReveal(root);
  initArrows(root);
  initSlines(root);
}

document.addEventListener("DOMContentLoaded", () => initMotion());
